var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B84848",
  d: "M5.243.314.314 5.243a1.07 1.07 0 1 0 1.514 1.514l4.177-4.166 4.167 4.166a1.07 1.07 0 1 0 1.514-1.514L6.757.314a1.07 1.07 0 0 0-1.514 0"
})));
export { SvgOpen as ReactComponent };
export default __webpack_public_path__ + "dfd18243dfb810d2495a6821658445e4.svg";